import { createSlice } from '@reduxjs/toolkit';
import { apiActivateUser, getRegisteredUsers } from '../auth/api';
const userSlice = createSlice({
  name: 'user',
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setUser: (state, action) => {
      state.loading = false;
      state.error = null;
      state.list = action.payload;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setLoading, stopLoading, setUser, setError } = userSlice.actions;

export const fetchUserAsync = (appId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const users = await getRegisteredUsers(appId);
    dispatch(setUser(users));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const activateUser = (appId,userId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    await apiActivateUser(userId);
     const users = await getRegisteredUsers(appId);
    dispatch(setUser(users));
  } catch (error) {
    dispatch(setError(error.message));
  }
};



export default userSlice.reducer;
